import ReactDOM from 'react-dom';
import App from './app/layout/App';

/* Global Styles */
import './index.css';

/* Boostrap Styles */
import 'bootstrap/dist/css/bootstrap.css';

ReactDOM.render(
    <App />,
  document.getElementById('root')
);